import React, { Component } from 'react';
import { Card, Button } from 'antd';
import './CollapseCard.less';

class CollapseCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            collapsed: this.props.collapsed ? true : false
        };
    }

    toggleCollapsed = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }

    render() {
        return (
            <Card size={this.props.size} className={this.state.collapsed ? 'c-card c-card-hide' : 'c-card'}
                title={this.props.title}
                extra={
                    this.state.collapsed ? <Button size="small" shape="circle" icon="down" onClick={this.toggleCollapsed} />
                        : <Button size="small" shape="circle" icon="up" onClick={this.toggleCollapsed} />
                }>
                {this.props.children}
            </Card>
            );
    }
}
export default CollapseCard;
